import { render, staticRenderFns } from "./list4Other.vue?vue&type=template&id=15fcb826&scoped=true"
import script from "./list4Other.vue?vue&type=script&lang=js"
export * from "./list4Other.vue?vue&type=script&lang=js"
import style0 from "./list4Other.vue?vue&type=style&index=0&id=15fcb826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fcb826",
  null
  
)

export default component.exports